<template>
  <f7-page class="page">
    <f7-navbar
      v-if="mostrarNavbarFrm"
      sliding
      no-shadow
      :parent-theme="parentTheme != null ? parentTheme : appTheme"
    >
      <div class="lefth">
        <f7-link back>
          <img
            alt="iconBack"
            src="@/static/icons/back.svg"
          >
        </f7-link>
      </div>
    </f7-navbar>

    <div class="div-frmNuevoPaleSinPedidoPlanificado">
      <f7-row class="row-elementosFrm">
        <f7-button
          small
          fill
          class="btn-confeccion"
          @click="$refs.FrmConfectionsForPalletizing.open()"
        >
          {{ $t('common.assemblies') }}
        </f7-button>
      </f7-row>
      <f7-row class="row-elementosFrm">
        <f7-col width="50">
          <f7-row>
            <f7-col width="100">
              <!-- <UCFamiliasDeArticulos
                plantilla="P2"
                :valor-por-defecto="familiaDelProductoSeleccionada"
                :parent-theme="parentTheme != null ? parentTheme : appTheme"
              /> -->
              <UCSearchEntityERP
                ref="UCFamiliaArticulo"
                :title="$t('searchEntity.articleFamily.title.family').toUpperCase()"
                :placeholder="$t('searchEntity.articleFamily.placeholder.selectAFamily')"
                :search-text="$t('searchEntity.articleFamily.searchText')"
                :search-cancellation-text="$t('searchEntity.articleFamily.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.articleFamily.searchNotFoundText')"
                :end-point-for-list="obtenerFamiliaArticulos"
                :end-point-for-code-search="obtenerFamiliaArticulos"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventFamiliaArticulosSelected"
              />
            </f7-col>
          </f7-row>
          <f7-row>
            <f7-col width="100">
              <UCSearchEntityERP
                ref="UCAticulosDeUnaFamilia"
                :title="$t('common.product').toUpperCase()"
                :placeholder="$t('searchEntity.product.placeholder.selectAProduct')"
                :search-text="$t('searchEntity.product.searchText')"
                :search-cancellation-text="$t('searchEntity.product.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.product.searchNotFoundText')"
                :end-point-for-list="obtenerArticuloFamilia"
                :end-point-for-code-search="obtenerArticuloFamilia"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre', 'Descripcion']"
                :pre-property-entity-shown-list-subtitle="[
                  `${$t('common.name')}: `,
                  `${$t('common.description')}: `,
                ]"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :disabled="familiaDelProductoSeleccionada == null"
                :search-in="['.item-title', '.subtitle0', '.subtitle1']"
                @selection="EventArticuloFamiliaSelected"
              >
                <template #subtitle-2="{ item }">
                  <div>
                    {{ item.Descripcion }}
                  </div>
                </template>
              </UCSearchEntityERP>
            </f7-col>
          </f7-row>
          <f7-row>
            <f7-col width="100">
              <!-- <UCArticulosTipoPale
                plantilla="P2"
                :parent-theme="parentTheme != null ? parentTheme : appTheme"
              /> -->
              <UCSearchEntityERP
                ref="UCTipoDePale"
                :title="$t('common.pallet').toUpperCase()"
                :placeholder="$t('searchEntity.pallet.placeholder.palletType')"
                :search-text="$t('searchEntity.pallet.searchText')"
                :search-cancellation-text="$t('searchEntity.pallet.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.pallet.searchNotFoundText')"
                :end-point-for-list="obtenerTipoDePale"
                :end-point-for-code-search="obtenerTipoDePale"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre', 'Descripcion']"
                :pre-property-entity-shown-list-subtitle="[
                  `${$t('common.name')}: `,
                  `${$t('common.description')}: `,
                ]"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :search-in="['.item-title', '.subtitle0', '.subtitle1']"
                @selection="EventTipoDePaleSelected"
              >
                <template #subtitle-2="{ item }">
                  <div>
                    {{ item.Descripcion }}
                  </div>
                </template>
              </UCSearchEntityERP>
            </f7-col>
          </f7-row>
        </f7-col>
        <f7-col width="50">
          <f7-row>
            <f7-col width="100">
              <!-- <UCArticulosTipoEnvase
                plantilla="P2"
                :parent-theme="parentTheme != null ? parentTheme : appTheme"
              /> -->
              <UCSearchEntityERP
                ref="UCEnvases"
                :title="$t('common.package').toUpperCase()"
                :placeholder="$t('common.package')"
                :search-text="$t('searchEntity.container.searchText')"
                :search-cancellation-text="$t('searchEntity.container.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.container.searchNotFoundText')"
                :end-point-for-list="obtenerEnvases"
                :end-point-for-code-search="obtenerEnvases"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre', 'Descripcion']"
                :pre-property-entity-shown-list-subtitle="[
                  `${$t('common.name')}: `,
                  `${$t('common.description')}: `,
                ]"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :search-in="['.item-title', '.subtitle0', '.subtitle1']"
                @selection="EventEnvaseSelected"
              >
                <template #subtitle-2="{ item }">
                  <div>
                    {{ item.Descripcion }}
                  </div>
                </template>
              </UCSearchEntityERP>
            </f7-col>
          </f7-row>
          <f7-row>
            <f7-col width="100">
              <!-- <UCMarcas
                plantilla="P2"
                :parent-theme="parentTheme != null ? parentTheme : appTheme"
              /> -->
              <UCSearchEntityERP
                ref="UCMarcas"
                :title="$t('common.brands').toUpperCase()"
                :placeholder="$t('common.brands')"
                :search-text="$t('searchEntity.brand.searchText')"
                :search-cancellation-text="$t('searchEntity.brand.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.brand.searchNotFoundText')"
                :end-point-for-list="obtenerMarcas"
                :end-point-for-code-search="obtenerMarcas"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventMarcaSelected"
              />
            </f7-col>
          </f7-row>
          <f7-row>
            <!-- Cantidad Envases por Palé -->
            <div class="div-cantidadEnvasesPorPale">
              <span class="span-texto-azulOscuro-14-500">
                {{ $t('common.packagesPerPallet').toUpperCase() }}
              </span>
              <input
                id="number"
                type="number"
                :placeholder="$t('common.quantity')"
                :value="cantidadEnvasesPorPalet"
                accept="number"
                min="1"
                @input="cantidadEnvasesPorPalet = $event.target.value"
              >
            </div>
          </f7-row>
        </f7-col>
      </f7-row>

      <div class="div-elementoSeparador-90 div-separador" />
      <div class="div-opcionesActions">
        <f7-row>
          <f7-col
            width="50"
            class="col-izquierdaActions"
          >
            <a
              class="link link-izquierdaActions-2"
              @click="CancelarNuevoPale()"
            >
              {{ $t('common.cancel').toUpperCase() }}
            </a>
          </f7-col>
          <f7-col
            width="50"
            class="col-derechaActions"
          >
            <a
              class="link link-derechaActions-2"
              @click="ConfirmarOperacion()"
            >
              {{ $t('common.confirm').toUpperCase() }}
            </a>
          </f7-col>
        </f7-row>
      </div>
    </div>
    <FrmConfectionsForPalletizing
      ref="FrmConfectionsForPalletizing"
      @confection-selected="setConfection"
    />
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA, {
  callObtenerArticulos,
  callObtenerFamiliasDeArticulos,
  callObtenerMarcas,
} from '@/js/services/traceability/APITraceability';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';
import FrmConfectionsForPalletizing from '@/pages/production/traceability/palletizing/FrmConfectionsForPalletizing.vue';
import { TipoArticulo } from '@/js/common/enum';
import { useParamRef } from '@erpagroapp/params';

/** @import { PropType } from 'vue' */
/** @import { Partida } from '@erpagroapp/types' */

export default {
  name: 'FrmNewPalletWithoutPlannedOrder',
  components: {

    UCSearchEntityERP,
    FrmConfectionsForPalletizing,
  },
  props: {
    activo: {
      type: Boolean,
      default: true,
    },
    mostrarNavbarFrm: {
      type: Boolean,
      default: true,
    },
    parentTheme: { type: Object, default: null }, // Si se define este tema, reemplazara el tema appTheme local
    partidasActivas: {
      type: /** @type {PropType<Partida[]>} */ (
        Array
      ),
      default: () => [],
    },
  },

  emits: [
    'cerrarFrm',
    'nuevoPaleSinPedidoPlanificadoGenerado',
  ],

  data() {
    return {
      puntoPaletizadoSeleccionado: null,
      lineaProduccionSeleccionada: null,
      familiaDelProductoSeleccionada: null, // Mantiene la familia del producto seleccionada.
      articuloDeTipoProductoSeleccionado: null, // Mantiene el tipo de Producto seleccionado.
      articuloDeTipoEnvaseSeleccionado: null, // Mantiene el tipo de envase seleccionado.
      articuloDeTipoPaleSeleccionado: null, // Mantiene el tipo de Palé seleccionado.
      marcaSeleccionada: null, // Mantiene la marca seleccionada.
      cantidadEnvasesPorPalet: 0, // Cantidad envases por palé establecida
      envasadoPorDefectoMarca: useParamRef('EnvasadoPorDefectoMarca'),
      envasadoPorDefectoPaletRecoleccion: useParamRef('EnvasadoPorDefectoPaletRecoleccion'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDePaletizadoSeleccionado',
      'lineaDeProduccionSeleccionada',
      'familiaArticuloSeleccionada',
    ]),

    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
  },
  watch: {
    activo(val) {
      if (val != null && val !== false) {
        this.InicializarFrm();
      }
    },
  },
  methods: {
    async InicializarFrm() {
      Log(this, this.InicializarFrm.name);
      this.puntoPaletizadoSeleccionado = this.puntoDePaletizadoSeleccionado;
      this.lineaProduccionSeleccionada = this.lineaDeProduccionSeleccionada;
      if (this.lineaProduccionSeleccionada.Id_FincaRelacionada !== 0) {
        await this.GetDefaultArticlesFamilies();
        await this.GetDefaultPalletType();
        await this.GetDefaultbrand();
      } else {
        const tempFamiliaDelProductoAlInicioDelFormulario = this.familiaArticuloSeleccionada;
        if (tempFamiliaDelProductoAlInicioDelFormulario) {
          this.familiaDelProductoSeleccionada = tempFamiliaDelProductoAlInicioDelFormulario;
        }
      }
    },

    RestablecerValores() {
      Log(this, this.RestablecerValores.name);
      this.articuloDeTipoProductoSeleccionado = null;
      this.articuloDeTipoEnvaseSeleccionado = null;
      this.articuloDeTipoPaleSeleccionado = null;
    },

    ConfirmarOperacion() {
      Log(this, this.ConfirmarOperacion.name);

      if (!this.Validar()) {
        return;
      }

      if (!this.VerificarExistePartidaActivaParaFamilia(this.familiaDelProductoSeleccionada)) {
        // Se muestra un Toast de forma informativa, la generación del palé no debe bloquearse
        HiNotification.Toast(this.$t('production.newPallet.validation.noActiveBatchesDumpedToastText'), 3000);
      }

      const self = this;
      this.GenerarPaleSinAsociarAPedidoPlanificado().then(() => {
        self.$emit('nuevoPaleSinPedidoPlanificadoGenerado');
        self.$emit('cerrarFrm');
      })
        .catch((error) => {
          HiNotification.Toast(this.$t('production.newPallet.confirm.errorToastText'), 3000);
          LogError(this, this.ConfirmarOperacion.name, error);
        });
    },
    EventFamiliaArticulosSelected(obj) {
      Log(this, this.EventFamiliaArticulosSelected.name);

      this.familiaDelProductoSeleccionada = obj;
    },
    EventArticuloFamiliaSelected(obj) {
      Log(this, this.EventArticuloFamiliaSelected.name);
      this.articuloDeTipoProductoSeleccionado = obj;
    },
    /* ARTICULOS POR FAMILIA  */
    obtenerArticuloFamilia() {
      Log(this, this.obtenerArticuloFamilia.name);
      return ConexionTA.callObtenerArticulosMateriaPrimaDeUnaFamilia(this.familiaDelProductoSeleccionada.Id);
    },
    /* familia de articulos */
    obtenerFamiliaArticulos(value) {
      Log(this, this.obtenerFamiliaArticulos.name);
      if (this.lineaProduccionSeleccionada.Id_FincaRelacionada !== 0) {
        return ConexionTA.callObtenerFamiliasDeArticulosRecoleccion(0, value, this.lineaProduccionSeleccionada.Id_FincaRelacionada);
      }
      return callObtenerFamiliasDeArticulos({ codigoFamilia: value });
    },

    async EventEnvaseSelected(obj) {
      Log(this, this.EventEnvaseSelected.name);
      if (obj) {
        this.articuloDeTipoEnvaseSeleccionado = obj;
        await this.ObtenerDatosComplementariosArticulo(this.articuloDeTipoEnvaseSeleccionado.Id);
      }
    },
    /* Envases */
    obtenerEnvases(value) {
      Log(this, this.obtenerEnvases.name);
      if (this.lineaProduccionSeleccionada.Id_FincaRelacionada !== 0) {
        return ConexionTA.callObtenerEnvasesParaRecoleccion(0, value);
      }
      return callObtenerArticulos({
        tipoArticulo: TipoArticulo.Envase,
        codigoArticulo: value,
      });
    },
    EventTipoDePaleSelected(obj) {
      Log(this, this.EventTipoDePaleSelected.name);
      this.articuloDeTipoPaleSeleccionado = obj;
    },
    /* tipo palet */
    obtenerTipoDePale(value) {
      Log(this, this.obtenerTipoDePale.name);
      if (this.lineaProduccionSeleccionada.Id_FincaRelacionada !== 0) {
        return ConexionTA.callObtenerPaletsParaRecoleccion(0, value);
      }
      return callObtenerArticulos({
        tipoArticulo: TipoArticulo.Palet,
        codigoArticulo: value,
      });
    },

    /* tmarcas */
    EventMarcaSelected(obj) {
      Log(this, this.EventMarcaSelected.name);
      this.marcaSeleccionada = obj;
    },
    obtenerMarcas(value) {
      Log(this, this.obtenerMarcas.name);
      return callObtenerMarcas({ codigoMarca: value });
    },

    Validar() {
      Log(this, this.Validar.name);
      if (this.articuloDeTipoProductoSeleccionado == null) {
        HiNotification.Toast(this.$t('production.newPallet.validation.selectProductToastText'));
        return false;
      }
      if (this.articuloDeTipoPaleSeleccionado == null) {
        HiNotification.Toast(this.$t('production.newPallet.validation.selectPalletTypeToastText'));
        return false;
      }
      if (this.articuloDeTipoEnvaseSeleccionado == null) {
        HiNotification.Toast(this.$t('production.newPallet.validation.selectPackagingTypeToastText'));
        return false;
      }
      return true;
    },

    CancelarNuevoPale() {
      Log(this, this.CancelarNuevoPale.name);
      this.$emit('cerrarFrm');
    },
    setConfection(value) {
      Log(this, this.setConfection.name);
      if (value.Producto !== null) {
        this.$refs.UCFamiliaArticulo.SelectEntity(value.Producto.Familia, false);
        this.familiaDelProductoSeleccionada = value.Producto.Familia;
      }
      if (value.Producto !== null) {
        this.$refs.UCAticulosDeUnaFamilia.SelectEntity(value.Producto, false);
        this.articuloDeTipoProductoSeleccionado = value.Producto;
      }
      if (value.Palet !== null) {
        this.$refs.UCTipoDePale.SelectEntity(value.Palet, false);
        this.articuloDeTipoPaleSeleccionado = value.Palet;
      }
      if (value.Envase !== null) {
        this.$refs.UCEnvases.SelectEntity(value.Envase, false);
        this.articuloDeTipoEnvaseSeleccionado = value.Envase;
      }
      if (value.Marca !== null) {
        this.$refs.UCMarcas.SelectEntity(value.Marca, false);
        this.marcaSeleccionada = value.Marca;
      }
      this.cantidadEnvasesPorPalet = value.EnvasesPorPalet;
    },
    VerificarExistePartidaActivaParaFamilia(objFamiliaProducto) {
      Log(this, this.VerificarExistePartidaActivaParaFamilia.name);

      try {
        let tempListPartidasActivasDeLaFamiliaBuscada = [];

        // Si la familia es la misma.
        tempListPartidasActivasDeLaFamiliaBuscada = this.partidasActivas.filter((p) => p.Articulo.Familia.Id === objFamiliaProducto.Id);
        if (tempListPartidasActivasDeLaFamiliaBuscada.length > 0) {
          return true;
        }

        // Si la familia no es la misma comparamos con la de nivel superior.
        tempListPartidasActivasDeLaFamiliaBuscada = this.partidasActivas.filter((p) => p.Articulo.Familia.FamiliaNivelSuperior.Id === objFamiliaProducto.FamiliaNivelSuperior.Id && p.Articulo.Familia.FamiliaNivelSuperior.EsFiltroEnAsignacionPartidasOrigenTrazabilidad === objFamiliaProducto.FamiliaNivelSuperior.EsFiltroEnAsignacionPartidasOrigenTrazabilidad);
        if (tempListPartidasActivasDeLaFamiliaBuscada.length > 0) {
          return true;
        }

        // No hay partidas activas del producto del que se quiere iniciar el palé (mostramos mensaje)
        return false;
      } catch (error) {
        LogError(this, this.VerificarExistePartidaActivaParaFamilia.name, error);
        return true; // Continuamos.
      }
    },

    GenerarPaleSinAsociarAPedidoPlanificado() {
      Log(this, this.GenerarPaleSinAsociarAPedidoPlanificado.name);
      PreloaderGH(true, false, this.$t('production.newPallet.confirm.preloaderText'));
      return new Promise((resolve, reject) => {
        ConexionTA.callGenerarPaleSinAsociarAPedidoPlanificado(
          this.puntoPaletizadoSeleccionado.Id,
          this.lineaProduccionSeleccionada.Id,
          this.articuloDeTipoPaleSeleccionado.Id,
          this.articuloDeTipoEnvaseSeleccionado.Id,
          this.cantidadEnvasesPorPalet,
          this.marcaSeleccionada != null ? this.marcaSeleccionada.Id : 0,
          this.articuloDeTipoProductoSeleccionado.Id,
        ).then((result) => {
          if (result.Valor) {
            PreloaderGH(false);
            resolve(JSON.parse(result.Mensaje));
          } else {
            PreloaderGH(false);
            reject();
            HiNotification.Toast(result.Mensaje);
          }
        })
          .catch((error) => {
            LogError(this, this.GenerarPaleSinAsociarAPedidoPlanificado.name, error);
            reject();
            PreloaderGH(false);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          });
      });
    },
    GetDefaultArticlesFamilies() {
      Log(this, this.GetDefaultArticlesFamilies.name);
      if (this.lineaProduccionSeleccionada.Id_FincaRelacionada !== 0) {
        callExecuteSPERP(
          'APPERPAGRO_FamiliasArticuloXFincaCultivoActivo',
          [{ NombreParametro: 'idFinca', Valor: this.lineaProduccionSeleccionada.Id_FincaRelacionada }],
          'Comun.FamiliaArticuloJSON',
        ).then((result) => {
          if (result.status !== 200) {
            return;
          }
          if (result.data.length > 0) {
            this.$refs.UCFamiliaArticulo.SelectEntity(result.data[0], true);
          }
        });
      }
    },
    async GetDefaultPalletType() {
      Log(this, this.GetDefaultPalletType.name);
      if (this.lineaProduccionSeleccionada.Id_FincaRelacionada !== 0) {
        if (this.envasadoPorDefectoPaletRecoleccion !== null && this.envasadoPorDefectoPaletRecoleccion !== '') {
          const result = await callObtenerArticulos({
            tipoArticulo: TipoArticulo.Palet,
            codigoArticulo: this.envasadoPorDefectoPaletRecoleccion,
          });
          if (result.Valor) {
            const palletsList = JSON.parse(result.Mensaje);
            if (palletsList.length > 0) {
              this.$refs.UCTipoDePale.SelectEntity(palletsList[0], true);
            }
          }
        }
      }
    },
    async GetDefaultbrand() {
      Log(this, this.GetDefaultbrand.name);
      if (this.lineaProduccionSeleccionada.Id_FincaRelacionada !== 0) {
        if (this.envasadoPorDefectoMarca !== null && this.envasadoPorDefectoMarca !== '') {
          const result = await callObtenerMarcas({ codigoMarca: this.envasadoPorDefectoMarca });
          if (result.Valor) {
            const brandList = JSON.parse(result.Mensaje);
            if (brandList.length > 0) {
              this.$refs.UCMarcas.SelectEntity(brandList[0], true);
            }
          }
        }
      }
    },
    async ObtenerDatosComplementariosArticulo(idArticulo) {
      Log(this, this.ObtenerDatosComplementariosArticulo.name);
      await ConexionTA.callObtenerDatosComplementariosEntidadSeleccionada(idArticulo, 'Articulo', false).then((result) => {
        if (result.Valor) {
          const datosComplementarios = JSON.parse(result.Mensaje);
          datosComplementarios.forEach((element) => {
            if (element.Codigo === 'EXP') {
              if (element.Valor !== '') {
                this.cantidadEnvasesPorPalet = Number.parseInt(element.Valor, 10);
              }
            }
          });
        }
      });
    },

  },

};
</script>

<style scoped lang="scss">
.page {
  background-color: var(--f7-page-bg-color) !important;
}

.div-frmNuevoPaleSinPedidoPlanificado {
  margin-top: 30px;

  .row-elementosFrm {
    .col-50 {
      .row {
        margin-top: 15px;
      }
    }
  }

  .btn-confeccion {
    background-color: var(--his-plum-shadow);
  }
}

.div-cantidadEnvasesPorPale {
  display: flex;
  flex-direction: column;

  span {
    margin: var(--search-title-margin);
    color: var(--search-title-color);
    font-size: var(--search-title-font-size);
    font-weight: var(--search-title-weight);
    padding: var(--search-title-padding);
  }
}

#number {
  border: 1px solid var(--his-silver);
  border-radius: 8px;
  background-color: #fff;
  width: 100%;
  box-sizing: content-box;
  height: var(--search-input-height);
  color: var(--search-input-color);
  font-size: var(--search-input-font-size);
  padding: var(--search-input-padding);
}

.input-1 {
  width: 100%;
  padding-top: 21px;
  padding-left: 17px;
  color: var(--his-ash-gray);
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
}

.row-elementosFrm {
  margin-left: 10px;
  margin-right: 25px;
  margin-bottom: 5px;
}

.div-opcionesActions {
  width: 94%;
  bottom: 10px;
  position: absolute;
}

.div-separador {
  width: 94%;
  bottom: 45px;
  position: absolute;
}

.link-izquierdaActions-2 {
  color: #7a869a !important;
  font-size: 14px;
}

.link-derechaActions-2 {
  color: #7a869a !important;
  font-size: 16px;
  font-weight: 500;
}
</style>
